import React from "react";
import TextareaAutosize from "react-textarea-autosize";
import styled from "styled-components";
import Form from "../molecules/Form";

interface IProps {
  handleOpenImageModal: () => void;
  handleTextSubmit: (e: React.FormEvent<HTMLFormElement>) => void;
  value: string;
  handleTextChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  sending: boolean;
  scrollToBottom: () => void;
}

const MessageFooter: React.FC<IProps> = ({
  handleOpenImageModal,
  handleTextSubmit,
  value,
  handleTextChange,
  scrollToBottom,
  sending
}) => {
  return (
    <OutWrapper>
      <CameraIcon
        className="fas fa-camera-alt"
        onClick={handleOpenImageModal}
      />
      <TextMessageForm onSubmit={handleTextSubmit}>
        <TextArea
          useCacheForDOMMeasurements={true}
          value={value}
          onChange={handleTextChange}
          minRows={1}
          maxRows={4}
          onHeightChange={() => {
            scrollToBottom();
          }}
        />
        <Input type="submit" className={sending ? "sending" : ""} />
      </TextMessageForm>
    </OutWrapper>
  );
};

const OutWrapper = styled.div`
  background-color: #f7f7f7;
  border-top: 1px solid #ddd;
  display: flex;
  padding: 16px;
  align-items: flex-end;
`;

const CameraIcon = styled.div`
  font-size: 1.6rem;
  margin-right: 8px;
  line-height: 32px;
`;

const TextMessageForm = styled(Form)`
  width: 100%;
  display: flex;
  align-items: flex-end;
`;

const TextArea = styled(TextareaAutosize)`
  font-size: 0.8rem;
  width: 100%;
  padding: 6px;
  outline: none;
  line-height: 1.5;
  border: 1px solid #ddd;
  margin-right: 6px;
  border-radius: 4px;
`;

const Input = styled.input`
  background-color: #1772ff;
  height: 32px;
  color: #fff;
  box-shadow: none;
  outline: none;
  border: none;
  border-radius: 3px;
  padding: 0 12px;
  font-size: 0.7rem;
  &.sending {
    background-color: #2963bd;
  }
`;

export default MessageFooter;
